import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { voidParkingBillingSetting } from '../api/parking-billing-setting.ts';

export default function useVoidParkingBillSetting(): UseMutationResult<
  string,
  Error,
  string
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => voidParkingBillingSetting(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['parkingBillingSettings'] });
    },
  });
}
